<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" sm="3" md="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <ssh-form-global :mode="mode" :id="id"  :readonly="!isEditable"></ssh-form-global>
    </template>
  </page-outline>
</template>
<script>

import _ from 'lodash'
import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import SSHFormGlobal from "@/pages/security/SSHFormGlobal.vue";

export default {
  name: 'SSHForm',
  components: {
    'back-button': backButton,
    'ssh-form-global':SSHFormGlobal,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data: () => {
    return {
      formType: 'add',
      pageTitle: '',
    }
  },
  created () {
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_ssh')
  },
  methods: {
  }
}

</script>
